import { render, staticRenderFns } from "./ColorIndicationTab.vue?vue&type=template&id=f7232ef8&scoped=true&"
import script from "./ColorIndicationTab.vue?vue&type=script&lang=js&"
export * from "./ColorIndicationTab.vue?vue&type=script&lang=js&"
import style0 from "./ColorIndicationTab.vue?vue&type=style&index=0&id=f7232ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7232ef8",
  null
  
)

export default component.exports